import SlagIcon from '@Src/_basic/icons/GradientBackground/Slag';
import React, { useRef, useState } from 'react';
import MaterialsReceiptMakeUpOrderModal from '../MaterialsReceiptMakeUpOrderModal';

interface Props {
  selectedFactory: number;
}
export default function SlagButton(props: Props) {
  const clickedIdRef = useRef<string | null>(null);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { selectedFactory } = props;
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setModalOpen(true);
    const divId = event.currentTarget.id;
    clickedIdRef.current = divId;
  };
  const handleClose = () => {
    setModalOpen(false);
  };
  return (
    <>
      <MaterialsReceiptMakeUpOrderModal
        clickedIdRef={clickedIdRef}
        modalOpen={modalOpen}
        onClose={handleClose}
        selectedFactory={selectedFactory}
      />
      {selectedFactory === 0 ? (
        <div id="4" role="button" style={{ position: 'relative', cursor: 'not-allowed' }}>
          <SlagIcon />
        </div>
      ) : (
        <div id="4" role="button" style={{ position: 'relative', cursor: 'pointer' }} onClick={handleClick}>
          <SlagIcon />
        </div>
      )}
    </>
  );
}
